import { Component, Input, OnInit } from "@angular/core";
import { BehaviorSubject } from "rxjs";

import { CreditCardMasks, getCreditCardType } from "@salud/FacturacionCobranza/PagoEnLinea/Helpers/credit-card.helper";
import { CreditCardType } from "@salud/FacturacionCobranza/PagoEnLinea/Types/Enums/credit-card-type.enum";

@Component({
  selector: "app-credit-card",
  templateUrl: "./credit-card.component.html",
  styleUrls: ["./credit-card.component.scss"],
})
export class CreditCardComponent implements OnInit {
  @Input() public set creditCardNumber(creditCardNumber: string) {
    this.creditCardNumberSource.next(creditCardNumber);
  }

  public dividedDate: string;
  @Input() public set expirationDate(newExpirationDate: string) {
    if (newExpirationDate) {
      this.dividedDate = `${newExpirationDate.slice(0, 2)} / ${newExpirationDate.slice(2, 4)}`;
    } else {
      this.dividedDate = "";
    }
  }
  private creditCardNumberSource = new BehaviorSubject<string>("");

  public creditCardMask: string = CreditCardMasks[CreditCardType.Visa];

  public CreditCardType = CreditCardType;
  public currentCreditCardType: CreditCardType;
  public creditCardNumber$ = this.creditCardNumberSource.asObservable();
  public currentCreditCardNumber = "";

  public ngOnInit(): void {
    this.creditCardNumber$.subscribe((cardNumber) => {
      const creditCardType = getCreditCardType(cardNumber);
      this.currentCreditCardNumber = cardNumber;
      this.currentCreditCardType = getCreditCardType(cardNumber);
      if (creditCardType) {
        this.creditCardMask = CreditCardMasks[creditCardType];
      }
    });
  }
}
